import type { AxiosResponse } from "axios";
import { axiosRequest } from "../api.utils";
import { API_ROOT } from "services/baseURLs.config";
import type { ApplicationDto, ApplicationRequestDto } from "model/Application";

export interface PendingApplicationsCountResponse {
  readonly value: number;
}

const getGigApplications = (
  companyId: number,
  gigId: number,
  gigShiftId?: number,
): Promise<AxiosResponse<ApplicationDto[]>> => {
  let url = `${API_ROOT}/companies/${companyId}/gigs/${gigId}/applications?documents=false`;

  if (gigShiftId !== undefined) {
    url += `&gigShiftId=${gigShiftId}`;
  }

  return axiosRequest.auth.get<ApplicationDto[]>(url);
};

const updateApplicationStatus = async (
  companyId: number,
  applicationId: number,
  applicationData: ApplicationRequestDto,
): Promise<AxiosResponse<ApplicationDto>> => {
  return await axiosRequest.auth.put<ApplicationDto>(
    `${API_ROOT}/companies/${companyId}/applications/${applicationId}/status`,
    applicationData,
  );
};

const getApplicationById = async (
  companyId: number,
  applicationId: number,
): Promise<AxiosResponse<ApplicationDto>> => {
  return await axiosRequest.auth.get<ApplicationDto>(
    `${API_ROOT}/companies/${companyId}/applications/${applicationId}`,
  );
};

const getPaginatedApplications = (
  companyId: number,
  page: number,
  amount: number,
  filter: string,
): Promise<AxiosResponse<ApplicationDto[]>> => {
  return axiosRequest.auth.get<ApplicationDto[]>(
    `${API_ROOT}/companies/${companyId}/applications/v2?page=${page}&amount=${amount}&filter=${filter}&includeHidden=false`,
  );
};

const getPaginatedApplicationsPending = (
  companyId: number,
  page: number,
  amount: number,
): Promise<AxiosResponse<ApplicationDto[]>> => {
  return axiosRequest.auth.get<ApplicationDto[]>(
    `${API_ROOT}/companies/${companyId}/applications/v2?status=Pending&page=${page}&amount=${amount}&includeHidden=false`,
  );
};

const getAllPaginatedApplications = (
  companyId: number,
  page: number,
  amount: number,
): Promise<AxiosResponse<ApplicationDto[]>> => {
  return axiosRequest.auth.get<ApplicationDto[]>(
    `${API_ROOT}/companies/${companyId}/applications/v2?page=${page}&amount=${amount}&includeHidden=false`,
  );
};

const getPendingApplicationsCount = (
  companyId: number,
): Promise<AxiosResponse<PendingApplicationsCountResponse>> => {
  return axiosRequest.auth.get<PendingApplicationsCountResponse>(
    `${API_ROOT}/companies/${companyId}/applications/v2/count`,
  );
};

export const application = {
  updateApplicationStatus,
  getApplicationById,
  getGigApplications,
  getPaginatedApplications,
  getPendingApplicationsCount,
  getPaginatedApplicationsPending,
  getAllPaginatedApplications,
};
